var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Left",
    "data-name": "Icon/Left",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 5.813,
    height: 10.523,
    viewBox: "0 0 5.813 10.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M0,.633,4.545,5.261,0,9.889l.645.633L5.813,5.261.645,0Z",
    fill: "#1a1446"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue",
    "data-name": "Color/Liberty Blue"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M0,.633,4.545,5.261,0,9.889l.645.633L5.813,5.261.645,0Z",
    fill: "#1a1446"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-2",
    "data-name": "Color/Liberty Blue",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-3",
    "data-name": "Color/Liberty Blue",
    transform: "translate(-30 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy",
    "data-name": "Rectangle Copy",
    width: 67.333,
    height: 64.667,
    fill: "#1a1446"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.800221e1ef52173564087fb9add0e92c.svg";
export { ForwardRef as ReactComponent };